import { InjectionToken } from '@angular/core';
import { EmployeesPort } from './employees.port';

export const EMPLOYEES_PORT = new InjectionToken<EmployeesPort>('EMPLOYEES_PORT');
